/**
 * 悬浮视频组件，包括视频弹窗
 * @author ZhaoJian
 */

import React from 'react';
import Dialog from 'components/dialog';
import * as statisticSDK from 'utils/statisticSDK';
import { getSparkleVideo } from 'api/store';
import DelSparkleVideoImg from './images/del-sparkle-video.png';
import PlaySparkleVideoImg from './images/play.svg';
import './index.less';

export default class FloatVideo extends React.Component {
  constructor() {
    super();
    this.sparkleVideoPlayCount = 0; // 悬浮视频播放次数
    this.isMouseDown = false;
    this.isRequestAnimationFrameLock = false;
    this.initX = 0;
    this.initY = 0;
    this.dragBox = null;

    this.state = {
      sparkleVideoDialogVisible: false, // 控制技巧中心视频弹窗显示隐藏
      sparkleVideoSuspensionVisible: false, // 控制技巧中心悬浮视频显隐
      sparkleVideoSrc: '', // 悬浮视频路径
      sparkleVideoTitle: '', // 悬浮视频标题
      moreUrl: '', // 悬浮视频查看更多路径
      floatVideoLeft: undefined,
      floatVideoTop: undefined,
    };
  }

  componentDidMount() {
    this.initSparkleVideo();
  }

  // 初始化悬浮视频
  initSparkleVideo() {
    getSparkleVideo().then(list => {
      if (list && list.length) {
        this.setState({
          sparkleVideoSuspensionVisible: true, // 控制技巧中心悬浮视频显隐
          sparkleVideoSrc: list[0].videoUrl,
          sparkleVideoTitle: list[0].title,
          moreUrl: list[0].moreUrl,
        });
      }
    });
  }

  // 监听悬浮视频播放
  handleSparkleVideoPlay = () => {
    const { sparkleVideoTitle } = this.state;

    statisticSDK.pushCustomEvent('c_video', {
      c_elmname: this.sparkleVideoPlayCount === 0 ? '播放' : '重播',
      c_elmcontent: sparkleVideoTitle,
      c_elmtype: 'video',
      c_component: 'Video',
    });

    this.sparkleVideoPlayCount++;
  };

  // 监听悬浮视频暂停
  handleSparkleVideoPause = e => {
    const { sparkleVideoTitle } = this.state;

    statisticSDK.pushCustomEvent('c_video', {
      c_elmname: '暂停',
      c_elmcontent: sparkleVideoTitle,
      c_elmtype: 'video',
      c_component: 'Video',
      playlength: Number.parseInt(e.target.currentTime),
    });
  };

  // 监听悬浮视频播放完成
  handleSparkleVideoEnded = e => {
    const { sparkleVideoTitle } = this.state;

    statisticSDK.pushCustomEvent('c_video', {
      c_elmname: '完成播放',
      c_elmcontent: sparkleVideoTitle,
      c_elmtype: 'video',
      c_component: 'Video',
      playlength: Number.parseInt(e.target.currentTime),
    });
  };

  // 技巧中心弹窗入口视频
  renderSparkleVideo() {
    const { sparkleVideoSrc, sparkleVideoTitle, moreUrl = '' } = this.state;

    return (
      sparkleVideoSrc && (
        <div className="sparkle-dialog-wrapper">
          <video
            style={{
              width: '100%',
              height: '100%',
            }}
            autoPlay
            controls
            onPlay={this.handleSparkleVideoPlay}
            onPause={this.handleSparkleVideoPause}
            onEnded={this.handleSparkleVideoEnded}
            controlsList="nodownload"
            disablepictureinpicture="true"
            src={sparkleVideoSrc}
          />
          <div className="sparkle-dialog-look-more">
            <a
              href={moreUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                statisticSDK.pushCustomEvent('c_click', {
                  c_elmname: '查看更多',
                  c_elmcontent: sparkleVideoTitle,
                  c_elmtype: 'video',
                  c_component: 'PopUp',
                });
              }}>
              查看更多视频
            </a>
          </div>
        </div>
      )
    );
  }

  handleMouseDown = e => {
    const boxWidth = this.dragBox.getBoundingClientRect().width;
    const boxHeight = this.dragBox.getBoundingClientRect().height;
    const { clientWidth, clientHeight } = document.body;

    this.isMouseDown = true;
    this.initX = e.clientX - this.dragBox.offsetLeft;
    this.initY = e.clientY - this.dragBox.offsetTop;

    const handleMouseMove = e => {
      e.preventDefault();
      if (!this.isMouseDown || this.isRequestAnimationFrameLock) return;
      this.isRequestAnimationFrameLock = true;

      window.requestAnimationFrame(() => {
        this.isRequestAnimationFrameLock = false;

        const moveX = e.clientX - this.initX;
        const moveY = e.clientY - this.initY;

        if (moveX < 0) {
          this.setState({
            floatVideoLeft: 0,
          });
        } else if (moveX >= 0 && moveX <= clientWidth - boxWidth) {
          this.setState({
            floatVideoLeft: moveX,
          });
        } else {
          this.setState({
            floatVideoLeft: clientWidth - boxWidth,
          });
        }

        if (moveY < 0) {
          this.setState({
            floatVideoTop: 0,
          });
        } else if (moveY >= 0 && moveY <= clientHeight - boxHeight) {
          this.setState({
            floatVideoTop: moveY,
          });
        } else {
          this.setState({
            floatVideoTop: clientHeight - boxHeight,
          });
        }
      });
    };

    const handleMouseUp = () => {
      this.isMouseDown = false;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  render() {
    const {
      sparkleVideoDialogVisible,
      sparkleVideoSuspensionVisible,
      sparkleVideoSrc,
      sparkleVideoTitle,
      floatVideoLeft,
      floatVideoTop,
    } = this.state;

    return (
      <div
        className="float-video-container"
        style={{
          left:
            floatVideoLeft === undefined ? undefined : `${floatVideoLeft}px`,
          top: floatVideoTop === undefined ? undefined : `${floatVideoTop}px`,
          width: sparkleVideoSuspensionVisible ? undefined : 0,
          height: sparkleVideoSuspensionVisible ? undefined : 0,
        }}
        ref={node => {
          this.dragBox = node;
        }}>
        {sparkleVideoSuspensionVisible && (
          <div className="sparkle-video-mask-wrapper">
            <video autoPlay muted loop src={sparkleVideoSrc} />
            <div
              className="sparkle-video-mask"
              onMouseDown={this.handleMouseDown}
            />
            <img
              className="del-sparkle-video"
              src={DelSparkleVideoImg}
              alt=""
              onClick={() => {
                this.setState({
                  sparkleVideoSuspensionVisible: false,
                });
              }}
            />
            <img
              className="play-sparkle-video"
              src={PlaySparkleVideoImg}
              alt=""
              onClick={() => {
                statisticSDK.pushCustomEvent('c_click', {
                  c_elmname: '打开视频',
                  c_elmcontent: sparkleVideoTitle,
                  c_elmtype: 'video',
                  c_component: 'Widget',
                });

                this.setState({
                  sparkleVideoDialogVisible: true,
                  sparkleVideoSuspensionVisible: false,
                });
              }}
            />
          </div>
        )}

        {sparkleVideoDialogVisible && (
          <Dialog
            classname="float-video-dialog"
            style={{
              width: 900,
              height: 506.25,
            }}
            content={this.renderSparkleVideo()}
            closeBtn
            onClose={() => {
              this.sparkleVideoPlayCount = 0;
              this.setState({
                sparkleVideoDialogVisible: false,
                sparkleVideoSuspensionVisible: true,
              });
            }}
          />
        )}
      </div>
    );
  }
}
